import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=7ba1cdd0&scoped=true"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=7ba1cdd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba1cdd0",
  null
  
)

export default component.exports